export default __webpack_public_path__ + "static/media/garden_hose.5884b864.png";